import { useEffect } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import "./style.scss"

function Upload({ children, onCancel, className }) {
  useEffect(() => {
    return () => typeof onCancel === "function" && onCancel()
  }, [onCancel])

  return <div className={classNames("components_upload", className)}>
    <div className="upload-wrapper">
      {children}
    </div>
  </div>
}

Upload.propTypes = {
  className: PropTypes.string,
  onCancel: PropTypes.func,
}

export default Upload
